import { appStore } from "store";

export const useAccountId = (): string | null =>
  appStore((state) => state.tokenData?.CurrentAccount ?? null);
